import React from 'react';
import {Link} from "react-router-dom";

const Dropmenu = (props)=>{

    const id = props.id;
    const name = props.name;
    const dropmenuItems = props.dropmenuItems.data;
    const closeMobileMenu = props.closeMobileMenu;


    return(

    <>
        <input type="checkbox" id={id} />
        <label htmlFor={ id } className="mobile-item">{name}</label>
        <ul className="dropMenu">

        {
            dropmenuItems.map((item, index)=>{

                return(
                   
                        <li key={index} ><Link to={item.link}  onClick={closeMobileMenu} >{item.name}</Link></li>
                
                );

            })
        }


        </ul>
    </>         

    );


}

//React.memo() will store the component when its rendered for the first time and 
//will only change it and render it again when incoming components will have some changed values in them
//we will not use React.memo if props in the component change everytime ..w e will only use it when there are no props 
//or the props remain same in that component every time
//we are using memo in this because the values in the drop down will remain same for us so we dont need to render
//it again and again, we will not use memo if values(props) change in the dropdown

export default React.memo(Dropmenu);